import React from 'react'
import { useState, useEffect } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import "./index.css";
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchStudent_Enrollment_Report, fetchStudent_Characteristics, fetchStudent_Group, fetchStudent_Enrollment_By_Year,
  fetchStudent_Enrollment_By_Grade, fetchSchool_And_Centers, fetchSchools_Centers_Report, fetchAt_A_Glance_Top_Tile,
  fetchStudent_Characteristics_Line,
  fetchFinancial_Total_Revenue_piechart,
  fetchFinancial_Total_Expenses_piechart,
  fetchFinancial_top_tile
} from '../../redux/slices/counter';
import { Dropdown } from 'primereact/dropdown';

import {
  fetchEnrollment, fetchSpecial_Group, fetchEthnicity_Mix, fetchSPED_Enrollment, fetchNet_Movement, fetchGraduation_To_KG_Enrollment_Ratio,
  fetchInter_School_Conversion, fetchSchools_Biggest_Gainers, fetchSchools_Biggest_Losers, fetchTime_Analysis, fetchEnrollment_Time_Analysis,
  fetchEnrollment_Summary_By_Dimensions,
  fetchTeacherFTE,
  fetchStudentTeacherRatio,
  fetchStudentCounselorRatio,
  fetchTotal_Teacher_FTE,
  fetchKG_Grade12_Ratio
} from '../../redux/slices/enrollment';

import {
  fetchDistrict_Climate_Rating, fetchstudent_behavior_poor_performing_schools, fetchstudent_behavior_top_performing_schools,
  fetchStudent_Behavior_Incident_Type, fetchStudent_Behavior_Chart
} from '../../redux/slices/studentbehavior';

import {
  fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART, fetchImprovement_Tile_Report, fetchStrength_Tile_Report, fetchWeakness_Tile_Report,
  fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART_GRADUATION
} from '../../redux/slices/strengthweakness';

import {
  fetchstudent_performance_tile_report, fetchstudent_dimension_table_report, fetchstudent_dimension_report,
  fetchstudent_dimension_table_report_graduation,
  fetchstudent_dimension_report_graduation
} from '../../redux/slices/studentperformance';

import {
  fetchSchool_Performance_School_Type_Report, fetchSchool_Performance_Metric_Report,
  fetchSchool_Performance_Map_Report, fetchSchool_Performance_Pie_Chart_Report
} from '../../redux/slices/schoolperformance';
import { fetchMenu_School_Year, fetchMenu_School_Level, fetchMenu_School_Name, fetchMenu_Gender, fetchMenu_Grade, fetchMenu_Ethnicity, Apply, fetchMenu_Ell, fetchMenu_Economically, fetchMenu_Disabilities } from '../../redux/slices/filter';
import { fetchAbsentees, fetchAbsentees_Trend, fetchLongetivity_Milestone, fetchMajor_Absence_Reason, fetchRetention_Rate, fetchSchools_with_High_Absenteeism, fetchSchools_With_High_Absentees, fetchSchools_with_Least_Absenteeism, fetchStaff_Absenteeism, fetchStaff_Absenteeism_Gender, fetchStaff_Demographic_Snapshot, fetchStaff_Diversity, fetchStaff_Engagement_Index, fetchStaff_Retention_Snapshot, fetchStudent_Teacher_Ratio, fetchTeacher_NonTeacher_Ratio, fetchTop_Absence_Reason, fetchTotal_Staff, fetchTotal_Staff_Gender, fetchWhite_NonWhite } from '../../redux/slices/staffdetails';


function FilterComponent() {
  var pagename = window.location.pathname;

  const Menu_School_Yeardata = useSelector(state => state.filter.Menu_School_Year);
  const Menu_School_Leveldata = useSelector(state => state.filter.Menu_School_Level);
  const Menu_School_Namedata = useSelector(state => state.filter.Menu_School_Name);
  const Menu_Gender = useSelector(state => state.filter.Menu_Gender);
  const Menu_Grade = useSelector(state => state.filter.Menu_Grade);
  const Menu_Ethnicity = useSelector(state => state.filter.Menu_Ethnicity);
  const Menu_ELL = useSelector(state => state.filter.Menu_Ell);
  const Menu_FRL = useSelector(state => state.filter.Menu_Economically);
  const Menu_Disability = useSelector(state => state.filter.Menu_Disabilities);


  const [selectedMenu_School_Year, setselectedMenu_School_Year] = useState(Menu_School_Yeardata)
  const [selectedMenu_School_Level, setSelectedMenu_School_Level] = useState(Menu_School_Leveldata)
  const [selectedMenu_School_Name, setSelectedMenu_School_Name] = useState(Menu_School_Namedata)
  const [selectedMenu_Gender, setSelectedMenu_Gender] = useState(Menu_Gender)
  const [selectedMenu_Grade, setSelectedMenu_Grade] = useState(Menu_Grade)
  const [selectedMenu_Ethnicity, setSelectedMenu_Ethnicity] = useState(Menu_Ethnicity)
  const [selectedMenu_ELL, setSelectedMenu_ELL] = useState(Menu_ELL)
  const [selectedMenu_FRL, setSelectedMenu_FRL] = useState(Menu_FRL)
  const [selectedMenu_Disability, setSelectedMenu_Disability] = useState(Menu_Disability)

  var yearOptions = [];
  selectedMenu_School_Year?.forEach(year => {
    yearOptions.push({ 'name': year.SCHOOL_YEAR?.toString(), 'value': year.SCHOOL_YEAR?.split('-')[1] ?? null })
  })

  var schoolTypeOptions = [];
  selectedMenu_School_Level?.forEach(year => {
    schoolTypeOptions.push({ 'label': year.SCHOOL_LEVEL, 'value': year.SCHOOL_LEVEL })
  })


  var genderOptions = [];
  selectedMenu_Gender?.forEach(year => {
    genderOptions.push({ 'label': year["INITCAP(GENDER)"], 'value': year["INITCAP(GENDER)"] })
  })


  var ELLOptions = [];
  selectedMenu_ELL?.forEach(year => {
    ELLOptions.push({ 'label': year["STUDENT_ELL"], 'value': year["STUDENT_ELL"] })
  })

  var FRLOptions = [];
  selectedMenu_FRL?.forEach(year => {
    FRLOptions.push({ 'label': year["STUDENT_ECONOMICALLY_DISADVANTAGED"], 'value': year["STUDENT_ECONOMICALLY_DISADVANTAGED"] })
  })

  var DisabilityOptions = [];
  selectedMenu_Disability?.forEach(year => {
    DisabilityOptions.push({ 'label': year["STUDENT_SPECIAL_ABILITY"], 'value': year["STUDENT_SPECIAL_ABILITY"] })
  })

  let gradeOptions = [];
  const gradeOrder = ['PK', 'KG', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17'];


  if (Array.isArray(selectedMenu_Grade)) {
    const sortedSelectedMenu_Grade = [...selectedMenu_Grade].sort((a, b) => {
      return gradeOrder.indexOf(a.GRADE) - gradeOrder.indexOf(b.GRADE);
    });

    gradeOptions = sortedSelectedMenu_Grade.map(year => ({
      label: year.GRADE,
      value: year.GRADE
    }));
  }


  var ethinOption = [];
  selectedMenu_Ethnicity?.forEach(year => {
    ethinOption.push({ 'label': year.ETHNICITY, 'value': year.ETHNICITY })
  })

  var schoolnameOption = [];
  selectedMenu_School_Name?.forEach(year => {
    schoolnameOption.push({ 'label': year.SCHOOL_NAME, 'value': year.SCHOOL_NAME })
  })

  const dispatch = useDispatch();

  const [selectedYearreset, setSelectedYearreset] = useState({
    "columnName": "SCHOOL_YEAR",
    "columnValue": "2027",
    "excludeKeyword": false
  })
  const [selectedSchoolreset, setSelectedSchoolreset] = useState({
    "columnName": "SCHOOL_LEVEL",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGenderreset, setSelectedGenderreset] = useState({
    "columnName": "STUDENT_GENDER",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedEthincityreset, setSelectedEthincityreset] = useState({
    "columnName": "STUDENT_ETHNICITY",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGradereset, setSelectedGradereset] = useState({
    "columnName": "STUDENT_GRADE",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedschoolnamereset, setSelectedschoolnamereset] = useState({
    "columnName": "SCHOOL_OFFICIAL_NAME",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedELLreset, setSelectedELLreset] = useState({
    "columnName": "STUDENT_ELL",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedFRLreset, setSelectedFRLreset] = useState({
    "columnName": "STUDENT_ECONOMICALLY_DISADVANTAGED",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedDisabilityreset, setSelectedDisabilityreset] = useState({
    "columnName": "STUDENT_ECONOMICALLY_DISADVANTAGED",
    "columnValue": [],
    "excludeKeyword": false
  })
  const resetFilterFunc = () => {
    // window.sessionStorage.removeItem('allfilter');
    setSelectedYeardata("2027")
    setSelectedSchooldata([])
    setSelectedGenderdata([])
    setSelectedEthincitydata([])
    setSelectedGradedata([])
    setSelectedSchoolnamedata([])
    setSelectedELLdata([])
    setSelectedFRLdata([])
    setSelectedDisabilitydata([])
    
    const filter = removeNullFun1()
    const body = {
      "elasticQueryName": "",
      "filters": filter,
      "grad_filters":
        removeNullFunGrad1()
      ,
      "dynamicColumns": [],
    };
    handleChange(body)
    AppliedFilters(filter);
  }

  const removeNullFun1 = () => {
    let j = [
      selectedYearreset.columnValue.length && selectedYearreset,
      selectedSchoolreset.columnValue.length && selectedSchoolreset,
      selectedGenderreset.columnValue.length && selectedGenderreset,
      selectedEthincityreset.columnValue.length && selectedEthincityreset,
      selectedGradereset.columnValue.length && selectedGradereset,
      selectedschoolnamereset.columnValue.length && selectedschoolnamereset,
      selectedELLreset.columnValue.length && selectedELLreset,
      selectedFRLreset.columnValue.length && selectedFRLreset,
      selectedDisabilityreset.columnValue.length && selectedDisabilityreset,
    ]
    return j.filter(val => val !== 0);
  }

  const removeNullFunGrad1 = () => {
    let j = [
      selectedMeasure.columnValue.length && selectedMeasure,
      selectedSchoolType.columnValue.length && selectedSchoolType,
      selectedYearreset.columnValue.length && selectedYearreset,
      selectedSchoolreset.columnValue.length && selectedSchoolreset,
      selectedGenderreset.columnValue.length && selectedGenderreset,
      selectedEthincityreset.columnValue.length && selectedEthincityreset,
      selectedGradereset.columnValue.length && selectedGradereset,
      selectedschoolnamereset.columnValue.length && selectedschoolnamereset,
      selectedELLreset.columnValue.length && selectedELLreset,
      selectedFRLreset.columnValue.length && selectedFRLreset,
      selectedDisabilityreset.columnValue.length && selectedDisabilityreset,
    ]
    return j.filter(val => val !== 0);
  }
  // ---------------------------------------------------------------------------------------------------------
  const [selectedMeasure, setSelectedMeasure] = useState({
    "columnName": "MEASURE_TYPE",
    "columnValue": ["All"],
    "excludeKeyword": false
  })
  const [selectedSchoolType, setSelectedSchoolType] = useState({
    "columnName": "SCHOOL_OFFICIAL_NAME",
    "columnValue": ["DistrictWide"],
    "excludeKeyword": false
  })
  const [selectedYear, setSelectedYear] = useState({
    "columnName": "SCHOOL_YEAR",
    "columnValue": [],
    "excludeKeyword": false
  })
  const [selectedSchool, setSelectedSchool] = useState({
    "columnName": "SCHOOL_LEVEL",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGender, setSelectedGender] = useState({
    "columnName": "STUDENT_GENDER",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedEthincity, setSelectedEthincity] = useState({
    "columnName": "STUDENT_ETHNICITY",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGrade, setSelectedGrade] = useState({
    "columnName": "STUDENT_GRADE",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedschoolname, setSelectedschoolname] = useState({
    "columnName": "SCHOOL_OFFICIAL_NAME",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedELL, setSelectedELL] = useState({
    "columnName": "STUDENT_ELL",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedFRL, setSelectedFRL] = useState({
    "columnName": "STUDENT_ECONOMICALLY_DISADVANTAGED",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedDisability, setSelectedDisability] = useState({
    "columnName": "STUDENT_SPECIAL_ABILITY",
    "columnValue": [],
    "excludeKeyword": false
  })

  const AppliedFilters = (filter) => {
    const data = [selectedYear, selectedSchool, selectedGender, selectedEthincity, selectedGrade, selectedschoolname, selectedELL, selectedFRL, selectedDisability].filter(item => item?.columnValue?.length)
    dispatch(Apply(filter ?? data))
  }
  // ---------------------------------------------------------------------------------------------
  const [selectedYearFilter, setSelectedYearFilter] = useState({
    "columnName": "SCHOOL_YEAR",
    "columnValue": [],
    "excludeKeyword": false
  })
  const [selectedSchoolFilter, setSelectedSchoolFilter] = useState({
    "columnName": "SCHOOL_LEVEL",
    "columnValue": [],
    "excludeKeyword": false
  })
  const [selectedGenderFilter, setSelectedGenderFilter] = useState({
    "columnName": "GENDER",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedEthincityFilter, setSelectedEthincityFilter] = useState({
    "columnName": "ETHNICITY",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGradeFilter, setSelectedGradeFilter] = useState({
    "columnName": "GRADE",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedschoolnameFilter, setSelectedschoolnameFilter] = useState({
    "columnName": "SCHOOL_NAME",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedELLFilter, setSelectedELLFilter] = useState({
    "columnName": "STUDENT_ELL",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedFRLFilter, setSelectedFRLFilter] = useState({
    "columnName": "STUDENT_ECONOMICALLY_DISADVANTAGED",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedDisabilityFilter, setSelectedDisabilityFilter] = useState({
    "columnName": "STUDENT_SPECIAL_ABILITY",
    "columnValue": [],
    "excludeKeyword": false
  })

  // useEffect(()=>{
  //     dispatch(fetchMenu_School_Year({
  //       "elasticQueryName": "Menu_School_Year",
  //       "filters": [],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_School_Level({
  //       "elasticQueryName": "Menu_School_Level",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       },
  //     ],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_School_Name({
  //       "elasticQueryName": "Menu_School_Name",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       }],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_Gender({
  //       "elasticQueryName": "Menu_Gender",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       }],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_Grade({
  //       "elasticQueryName": "Menu_Grade",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       }],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_Ethnicity({
  //       "elasticQueryName": "Menu_Ethnicity",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       }],
  //       "dynamicColumns": [],
  //     }));
  //   },[])

  useEffect(() => {
    const handleBeforeUnload = () => {
      window.sessionStorage.removeItem('SchoolType');
      window.sessionStorage.removeItem('Year');
      window.sessionStorage.removeItem('Gender');
      window.sessionStorage.removeItem('Ethincity');
      window.sessionStorage.removeItem('Grade');
      window.sessionStorage.removeItem('EL');
      window.sessionStorage.removeItem('Free and Reduced Lunch');
      window.sessionStorage.removeItem('Students with Disabilities');
      window.sessionStorage.removeItem('enrollmentdimension');
      window.sessionStorage.removeItem('allfilter');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const getSessionData = (key, fallback) => {
    return JSON.parse(sessionStorage.getItem(key)) || fallback;
  };

  const [selectedYeardata, setSelectedYeardata] = useState(getSessionData("Year", "2027"));
  const [selectedSchooldata, setSelectedSchooldata] = useState(getSessionData("SchoolType", []));
  const [selectedGenderdata, setSelectedGenderdata] = useState(getSessionData("Gender", []));
  const [selectedEthincitydata, setSelectedEthincitydata] = useState(getSessionData("Ethincity", []));
  const [selectedGradedata, setSelectedGradedata] = useState(getSessionData("Grade", []));
  const [selectedSchoolnamedata, setSelectedSchoolnamedata] = useState(getSessionData("Schoolname", []));
  const [selectedELLdata, setSelectedELLdata] = useState(getSessionData("EL", []));
  const [selectedFRLdata, setSelectedFRLdata] = useState(getSessionData("Free and Reduced Lunch", []));
  const [selectedDisabilitydata, setSelectedDisabilitydata] = useState(getSessionData("Students with Disabilities", []));

  useEffect(() => {
    sessionStorage.setItem("Year", JSON.stringify(selectedYeardata));
  }, [selectedYeardata]);

  useEffect(() => {
    sessionStorage.setItem("SchoolType", JSON.stringify(selectedSchooldata));
  }, [selectedSchooldata]);

  useEffect(() => {
    sessionStorage.setItem("Gender", JSON.stringify(selectedGenderdata));
  }, [selectedGenderdata]);

  useEffect(() => {
    sessionStorage.setItem("Ethincity", JSON.stringify(selectedEthincitydata));
  }, [selectedEthincitydata]);

  useEffect(() => {
    sessionStorage.setItem("Grade", JSON.stringify(selectedGradedata));
  }, [selectedGradedata]);

  useEffect(() => {
    sessionStorage.setItem("Schoolname", JSON.stringify(selectedSchoolnamedata));
  }, [selectedSchoolnamedata]);

  useEffect(() => {
    sessionStorage.setItem("EL", JSON.stringify(selectedELLdata));
  }, [selectedELLdata]);

  useEffect(() => {
    sessionStorage.setItem("Free and Reduced Lunch", JSON.stringify(selectedFRLdata));
  }, [selectedFRLdata]);
  useEffect(() => {
    sessionStorage.setItem("Students with Disabilities", JSON.stringify(selectedDisabilitydata));
  }, [selectedDisabilitydata]);
  useEffect(() => {
    setselectedMenu_School_Year(Menu_School_Yeardata)
    let selectedArray = []
    // selectedYeardata?.map((k) => {
    //   selectedArray.push(k.value)
    // })
    setSelectedYear({
      "columnName": "SCHOOL_YEAR",
      "columnValue": selectedYeardata,
      "excludeKeyword": false
    });
    setSelectedYearFilter({
      "columnName": "SCHOOL_YEAR",
      "columnValue": selectedYeardata,
      "excludeKeyword": false
    });
  }, [selectedYeardata, Menu_School_Yeardata.length]);

  useEffect(() => {
    setSelectedMenu_School_Level(Menu_School_Leveldata)
    let selectedArray = []
    selectedSchooldata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedSchool({
      "columnName": "SCHOOL_LEVEL",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });

    setSelectedSchoolFilter({
      "columnName": "SCHOOL_LEVEL",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedSchooldata, Menu_School_Leveldata.length]);

  useEffect(() => {
    setSelectedMenu_Gender(Menu_Gender)
    let selectedArray = []
    selectedGenderdata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedGender({
      "columnName": "STUDENT_GENDER",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
    setSelectedGenderFilter({
      "columnName": "GENDER",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedGenderdata, Menu_Gender.length]);

  useEffect(() => {
    setSelectedMenu_Ethnicity(Menu_Ethnicity)
    let selectedArray = []
    selectedEthincitydata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedEthincity({
      "columnName": "STUDENT_ETHNICITY",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
    setSelectedEthincityFilter({
      "columnName": "ETHNICITY",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedEthincitydata, Menu_Ethnicity.length]);

  useEffect(() => {
    setSelectedMenu_Grade(Menu_Grade)
    let selectedArray = []
    selectedGradedata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedGrade({
      "columnName": "STUDENT_GRADE",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
    setSelectedGradeFilter({
      "columnName": "GRADE",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedGradedata, Menu_Grade.length]);

  useEffect(() => {
    setSelectedMenu_ELL(Menu_ELL)
    let selectedArray = []
    selectedELLdata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedELL({
      "columnName": "STUDENT_ELL",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });

    setSelectedELLFilter({
      "columnName": "STUDENT_ELL",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedELLdata, Menu_ELL?.length]);

  useEffect(() => {
    setSelectedMenu_FRL(Menu_FRL)
    let selectedArray = []
    selectedFRLdata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedFRL({
      "columnName": "STUDENT_ECONOMICALLY_DISADVANTAGED",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });

    setSelectedFRLFilter({
      "columnName": "STUDENT_ECONOMICALLY_DISADVANTAGED",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedFRLdata, Menu_FRL?.length]);

  useEffect(() => {
    setSelectedMenu_Disability(Menu_Disability)
    let selectedArray = []
    selectedDisabilitydata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedDisability({
      "columnName": "STUDENT_SPECIAL_ABILITY",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });

    setSelectedDisabilityFilter({
      "columnName": "STUDENT_SPECIAL_ABILITY",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedDisabilitydata, Menu_Disability?.length]);


  useEffect(() => {
    setSelectedMenu_School_Name(Menu_School_Namedata)
    let selectedArray = []
    selectedSchoolnamedata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedschoolname({
      "columnName": "SCHOOL_OFFICIAL_NAME",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });

    setSelectedschoolnameFilter({
      "columnName": "SCHOOL_NAME",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedSchoolnamedata, Menu_School_Namedata?.length]);


  const applyFilterFunc = () => {

    const body = {
      "elasticQueryName": "",
      "filters":
        removeNullFun()
      ,
      "grad_filters": removeNullFunGrad(),
      "dynamicColumns": [],
    };
    AppliedFilters()
    handleChange(body)


  }

  useEffect(() => {
    const bodyFilter = {
      "elasticQueryName": "",
      "filters":
        removeNullFunFilter()
      ,
      "dynamicColumns": [],
    };
    handleChangeFilter(bodyFilter)
  }, [selectedYearFilter, selectedSchoolFilter, selectedGenderFilter, selectedEthincityFilter, selectedGradeFilter, selectedschoolnameFilter, selectedELLFilter,selectedFRLFilter,selectedDisabilityFilter]);

  const removeNullFunFilter = () => {
    let j = [
      selectedYearFilter.columnValue.length && selectedYearFilter,
      selectedSchoolFilter.columnValue.length && selectedSchoolFilter,
      selectedGenderFilter.columnValue.length && selectedGenderFilter,
      selectedEthincityFilter.columnValue.length && selectedEthincityFilter,
      selectedGradeFilter.columnValue.length && selectedGradeFilter,
      selectedschoolnameFilter.columnValue.length && selectedschoolnameFilter,
      selectedELLFilter.columnValue.length && selectedELLFilter,
      selectedFRLFilter.columnValue.length && selectedFRLFilter,
      selectedDisabilityFilter.columnValue.length && selectedDisabilityFilter,
    ]
    return j.filter(val => val !== 0);
  }
  let enrollmentdimension = sessionStorage.getItem("enrollmentdimension")
  let selectedoptions = sessionStorage.getItem("selectedoptions")
  let selectedoptions1 = sessionStorage.getItem("selectedoptions1")
  let selectedoptions2 = sessionStorage.getItem("selectedoptions2")
  let selectedoptions3 = sessionStorage.getItem("selectedoptions3")
  let selectedmetric = sessionStorage.getItem("strengthselectedmetric")


  let performancesummary = sessionStorage.getItem("performancesummary")
  let studentselectmetric = sessionStorage.getItem("studentselectedmetric")

  function removeGradFilter(data) {
    // Filter out the object with the specified columnName from grad_filters
    data.grad_filters = data.grad_filters.filter(f => f.columnName !== "SCHOOL_OFFICIAL_NAME");
    return data;
  }
  const handleChange = (body) => {
    // debugger

    const schoolYears = [
      ...body.filters.filter(f => f.columnName === "SCHOOL_YEAR").map(f => f.columnValue),

    ];
    var Yearremove = body;
    Yearremove = Yearremove?.filters?.filter((item) => item.columnName != "SCHOOL_YEAR");
    var data1 = {
      "elasticQueryName": "",
      "filters": Yearremove,
      "dynamicColumns": [],
    }
    var dataenrollmentdimension = {
      "elasticQueryName": "",
      "filters": body?.filters,
      "dynamicColumns": [{ columnName: "#{dimension}", columnValue: [enrollmentdimension] }],
    }
    var filtereddata = body?.filters
    var datasankey = {
      "elasticQueryName": "",
      "filters": filtereddata,
      "dynamicColumns": [{ columnName: "#{dimension_1}", columnValue: [selectedoptions], "excludeKeyword": false },
      { columnName: "#{dimension_2}", columnValue: [selectedoptions1] },
      { columnName: "#{dimension_3}", columnValue: [selectedoptions2] },
      { columnName: "#{dimension_4}", columnValue: [selectedoptions3] },
      { columnName: "#{metric_id}", columnValue: [selectedmetric]}
      ],
    }

    var BodyStudentCharLine = {
      "elasticQueryName": "Student_Group",
      "filters": [{
        "columnName": "SCHOOL_YEAR",
        "columnValue": schoolYears[0],
        "excludeKeyword": false
      }],
      "dynamicColumns": [{
        "columnName": "#{year_filter}",
        "columnValue": "and SCHOOL_YEAR BETWEEN (" + (schoolYears[0] - 2) + ") AND " + schoolYears[0]
      }]
    }

    var filtereddatastudent = body?.filters
    var datastudent = {
      "elasticQueryName": "",
      "filters": filtereddatastudent,
      "dynamicColumns": [
        { columnName: "#{dimension}", columnValue: [performancesummary], "excludeKeyword": false },
        { columnName: "#{metric_id}", columnValue: [studentselectmetric], "excludeKeyword": false },
      ],
    }
    sessionStorage.setItem("allfilter", JSON.stringify(body));
    if (pagename == '/') {
      dispatch(fetchAt_A_Glance_Top_Tile(body));
      dispatch(fetchStudent_Enrollment_Report(removeGradFilter(body)));
      dispatch(fetchStudent_Characteristics(removeGradFilter(body)));
      dispatch(fetchStudent_Group(removeGradFilter(body)));
      dispatch(fetchStudent_Enrollment_By_Year(data1));
      dispatch(fetchStudent_Enrollment_By_Grade(removeGradFilter(body)));
      dispatch(fetchStudent_Characteristics_Line(BodyStudentCharLine))
      const newFilter = new Set(["STUDENT_ELL", "STUDENT_ECONOMICALLY_DISADVANTAGED", "STUDENT_SPECIAL_ABILITY"])
      const _newFilterRestrict = {...body, filters: body.filters.filter(item => !newFilter.has(item.columnName))}
      dispatch(fetchSchool_And_Centers(removeGradFilter(_newFilterRestrict)));
      dispatch(fetchSchools_Centers_Report(removeGradFilter(_newFilterRestrict)));
      // dispatch(fetchTotal_Teacher_FTE(_newFilterRestrict));
      // dispatch(fetchTeacherFTE(_newFilterRestrict));
      // dispatch(fetchStudentTeacherRatio(_newFilterRestrict));
      // dispatch(fetchStudentCounselorRatio(_newFilterRestrict));
      const _onlyYearbody = {...body, filters: body.filters.filter(item => item.columnName === 'SCHOOL_YEAR')}
      dispatch(fetchFinancial_top_tile(_onlyYearbody));
      dispatch(fetchFinancial_Total_Revenue_piechart(_onlyYearbody));
      dispatch(fetchFinancial_Total_Expenses_piechart(_onlyYearbody));
    } else if (pagename == '/enrollment') {
      dispatch(fetchEnrollment(removeGradFilter(body)));
      dispatch(fetchSpecial_Group(removeGradFilter(body)));
      dispatch(fetchSPED_Enrollment(removeGradFilter(body)));
      dispatch(fetchNet_Movement(removeGradFilter(body)));
      dispatch(fetchGraduation_To_KG_Enrollment_Ratio(removeGradFilter(body)));
      dispatch(fetchKG_Grade12_Ratio(removeGradFilter(body)));
      dispatch(fetchInter_School_Conversion(removeGradFilter(body)));
      dispatch(fetchSchools_Biggest_Gainers(removeGradFilter(body)));
      dispatch(fetchSchools_Biggest_Losers(removeGradFilter(body)));
      dispatch(fetchTime_Analysis(data1));
      dispatch(fetchEnrollment_Time_Analysis(removeGradFilter(body)));
      dispatch(fetchEnrollment_Summary_By_Dimensions(dataenrollmentdimension));
      const _onlyYearbody = {...body, filters: body.filters.filter(item => item.columnName === 'SCHOOL_YEAR')}
      dispatch(fetchEthnicity_Mix(removeGradFilter(_onlyYearbody)));
    } else if (pagename == '/studentbehavior') {
      dispatch(fetchDistrict_Climate_Rating(removeGradFilter(body)));
      dispatch(fetchstudent_behavior_poor_performing_schools(removeGradFilter(body)));
      dispatch(fetchstudent_behavior_top_performing_schools(removeGradFilter(body)));
      dispatch(fetchStudent_Behavior_Incident_Type(removeGradFilter(body)));
      dispatch(fetchStudent_Behavior_Chart(data1));
    } else if (pagename == '/StrengthWeakness') {
      dispatch(fetchImprovement_Tile_Report(body));
      dispatch(fetchStrength_Tile_Report(body));
      dispatch(fetchWeakness_Tile_Report(body));
      dispatch(fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART(datasankey));
      // dispatch(fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART_GRADUATION(datasankey));
    } else if (pagename == '/StudentPerformance') {
      dispatch(fetchstudent_performance_tile_report(body));
      dispatch(fetchstudent_dimension_table_report(datastudent));
      dispatch(fetchstudent_dimension_report(datastudent));
      // dispatch(fetchstudent_dimension_table_report_graduation(datastudent));
      // dispatch(fetchstudent_dimension_report_graduation(datastudent));
    } else if (pagename == '/schoolperformance') {
      dispatch(fetchSchool_Performance_School_Type_Report(removeGradFilter(body)));
      dispatch(fetchSchool_Performance_Metric_Report(removeGradFilter(body)));
      dispatch(fetchSchool_Performance_Map_Report(removeGradFilter(body)));
      dispatch(fetchSchool_Performance_Pie_Chart_Report(removeGradFilter(body)));
    } else if (pagename == '/staffdetails') {
      const newFilter = new Set(["GRADE", "STUDENT_ELL", "STUDENT_ECONOMICALLY_DISADVANTAGED", "STUDENT_SPECIAL_ABILITY"])
      const _staffDetailsFilters = {...body, filters: body.filters.filter(item => !newFilter.has(item.columnName))}
      // dispatch(fetchStaff_Engagement_Index(_staffDetailsFilters));
      dispatch(fetchLongetivity_Milestone(_staffDetailsFilters));
      dispatch(fetchTotal_Staff(_staffDetailsFilters));
      dispatch(fetchRetention_Rate(_staffDetailsFilters));
      dispatch(fetchStaff_Absenteeism(_staffDetailsFilters));
      dispatch(fetchStaff_Absenteeism_Gender(_staffDetailsFilters));
      dispatch(fetchStudent_Teacher_Ratio(_staffDetailsFilters));
      dispatch(fetchSchools_with_High_Absenteeism(_staffDetailsFilters));
      dispatch(fetchSchools_with_Least_Absenteeism(_staffDetailsFilters));
      dispatch(fetchTop_Absence_Reason(_staffDetailsFilters));
      dispatch(fetchStaff_Demographic_Snapshot(_staffDetailsFilters));
      dispatch(fetchStaff_Retention_Snapshot(_staffDetailsFilters));
      dispatch(fetchStaff_Diversity(_staffDetailsFilters));
      dispatch(fetchTeacher_NonTeacher_Ratio(_staffDetailsFilters));
      dispatch(fetchWhite_NonWhite(_staffDetailsFilters));
      dispatch(fetchMajor_Absence_Reason(_staffDetailsFilters));
      dispatch(fetchSchools_With_High_Absentees(_staffDetailsFilters));
      dispatch(fetchAbsentees(_staffDetailsFilters));
      dispatch(fetchAbsentees_Trend(_staffDetailsFilters));
      dispatch(fetchTotal_Staff_Gender(_staffDetailsFilters));
    }
  }

  const removeNullFun = () => {
    let j = [
      selectedYear.columnValue.length && selectedYear,
      selectedSchool.columnValue.length && selectedSchool,
      selectedGender.columnValue.length && selectedGender,
      selectedEthincity.columnValue.length && selectedEthincity,
      selectedGrade.columnValue.length && selectedGrade,
      selectedschoolname.columnValue.length && selectedschoolname,
      selectedELL.columnValue.length && selectedELL,
      selectedFRL.columnValue.length && selectedFRL,
      selectedDisability.columnValue.length && selectedDisability,
    ]
    return j.filter(val => val !== 0);
  }

  const removeNullFunGrad = () => {
    let j = [
      selectedGender.columnValue.length == 0 && selectedEthincity.columnValue.length == 0 && selectedMeasure.columnValue.length && selectedMeasure,
      selectedGender.columnValue.length == 0 && selectedEthincity.columnValue.length == 0 && selectedSchoolType.columnValue.length && selectedSchoolType,
      selectedYear.columnValue.length && selectedYear,
      selectedSchool.columnValue.length && selectedSchool,
      selectedGender.columnValue.length == 0 && selectedEthincity.columnValue.length && selectedEthincity,
      selectedGender.columnValue.length && selectedGender,
      selectedschoolname.columnValue.length && selectedschoolname,
      selectedELL.columnValue.length && selectedELL,
      selectedFRL.columnValue.length && selectedFRL,
      selectedDisability.columnValue.length && selectedDisability,
    ]
    return j.filter(val => val !== 0 && val !== false);
  }


  const handleChangeFilter = (body) => {
    var Yearremove = body;
    var removeschoollevel = body;
    var removeschoolname = body;
    var removegrade = body;
    var removegender = body;
    var removeethnicity = body;
    var removeELL = body;
    var removeFRL = body;
    var removeDisability = body;
    Yearremove = Yearremove?.filters?.filter((item) => item.columnName != "SCHOOL_YEAR");
    var data1 = {
      "elasticQueryName": "",
      "filters": Yearremove,
      "dynamicColumns": [],
    }
    removeschoollevel = removeschoollevel?.filters?.filter((item) => item.columnName != "SCHOOL_LEVEL" && item.columnName != "SCHOOL_NAME"
      && item.columnName != "GRADE" && item.columnName != "GENDER" && item.columnName != "ETHNICITY"
    );
    var dataremoveschoollevel = {
      "elasticQueryName": "",
      "filters": removeschoollevel,
      "dynamicColumns": [],
    }
    removeschoolname = removeschoolname?.filters?.filter((item) => item.columnName != "SCHOOL_NAME");
    var dataremoveschoolname = {
      "elasticQueryName": "",
      "filters": removeschoolname,
      "dynamicColumns": [],
    }
    removegrade = removegrade?.filters?.filter((item) => item.columnName != "GRADE");
    var dataremovegrade = {
      "elasticQueryName": "",
      "filters": removegrade,
      "dynamicColumns": [],
    }
    removegender = removegender?.filters?.filter((item) => item.columnName != "GENDER");
    var dataremovegender = {
      "elasticQueryName": "",
      "filters": removegender,
      "dynamicColumns": [],
    }
    removeethnicity = removeethnicity?.filters?.filter((item) => item.columnName != "ETHNICITY");
    var dataremoveethnicity = {
      "elasticQueryName": "",
      "filters": removeethnicity,
      "dynamicColumns": [],
    }
    removeELL = removeELL?.filters?.filter((item) => item.columnName != "STUDENT_ELL");
    var dataremoveELL = {
      "elasticQueryName": "",
      "filters": removeELL,
      "dynamicColumns": [],
    }
    removeFRL = removeFRL?.filters?.filter((item) => item.columnName != "STUDENT_ECONOMICALLY_DISADVANTAGED");
    var dataremoveFRL = {
      "elasticQueryName": "",
      "filters": removeFRL,
      "dynamicColumns": [],
    }
    removeDisability = removeDisability?.filters?.filter((item) => item.columnName != "STUDENT_SPECIAL_ABILITY");
    var dataremoveDisability = {
      "elasticQueryName": "",
      "filters": removeDisability,
      "dynamicColumns": [],
    }
    dispatch(fetchMenu_School_Year(data1));
    dispatch(fetchMenu_School_Level(dataremoveschoollevel));
    dispatch(fetchMenu_School_Name(dataremoveschoolname));
    dispatch(fetchMenu_Gender(dataremovegender));
    dispatch(fetchMenu_Grade(dataremovegrade));
    dispatch(fetchMenu_Ethnicity(dataremoveethnicity));
    dispatch(fetchMenu_Ell(dataremoveELL));
    dispatch(fetchMenu_Economically(dataremoveFRL));
    dispatch(fetchMenu_Disabilities(dataremoveDisability));
  }

/* Dropdown Events */
const onShow = () => {
  document.body?.classList?.toggle("overflow-clip");
  document.body?.querySelector(".navSidebar .p-sidebar-content .p-tabview  .p-tabview-panels")?.classList.toggle("!overflow-y-hidden");
}
const onHide = () => {
  document.body?.classList?.remove("overflow-clip");
  document.body?.querySelector(".navSidebar .p-sidebar-content .p-tabview  .p-tabview-panels")?.classList.remove("!overflow-y-hidden");
}
/*  */

  return (
    <div >
      <div className='px-10 py-8'>

        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">School Year</label>
          {/* <MultiSelect
                         options={yearOptions}
                        value={selectedYeardata}
                         onChange={setSelectedYeardata}
                         overrideStrings={{
                           allItemsAreSelected: "All",
                         }}
                        labelledBy="Type to Search or Select"
                    /> */}
          <Dropdown onShow={onShow} onHide={onHide} value={selectedYeardata} onChange={(e) => setSelectedYeardata(e.value)} options={yearOptions} optionLabel="name"
            placeholder={selectedYeardata} className="w-full md:w-14rem text-xs" style={{ width: 193 }} />

        </form>
        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">School Type</label>
          <MultiSelect
            options={schoolTypeOptions}
            value={selectedSchooldata}
            onChange={setSelectedSchooldata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>

        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">School Name</label>
          <MultiSelect
            options={schoolnameOption}
            value={selectedSchoolnamedata}
            onChange={setSelectedSchoolnamedata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>

        {pagename != '/staffdetails' && <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">Grade</label>
          <MultiSelect
            options={gradeOptions}
            value={selectedGradedata}
            onChange={setSelectedGradedata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>}
        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">Ethnicity</label>
          <MultiSelect
            options={ethinOption}
            value={selectedEthincitydata}
            onChange={setSelectedEthincitydata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>
        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">Gender</label>
          <MultiSelect
            options={genderOptions}
            value={selectedGenderdata}
            onChange={setSelectedGenderdata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>
        {(pagename != '/staffdetails' && pagename != '/attendance') && <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">EL</label>
          <MultiSelect
            options={ELLOptions}
            value={selectedELLdata}
            onChange={setSelectedELLdata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>}
        {(pagename != '/staffdetails' && pagename != '/attendance') && <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">Free and Reduced Lunch</label>
          <MultiSelect
            options={FRLOptions}
            value={selectedFRLdata}
            onChange={setSelectedFRLdata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
            className="custom-multiselect"
          />

        </form>}
        {(pagename != '/staffdetails' && pagename != '/attendance') && <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">Students with Disabilities</label>
          <MultiSelect
            options={DisabilityOptions}
            value={selectedDisabilitydata}
            onChange={setSelectedDisabilitydata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
            className="custom-multiselect"
          />

        </form>}


        <button className='filterBut py-2 px-1' style={{ position: "relative", left: "20px" }} onClick={applyFilterFunc}>Apply</button>
        <button className='filterBut py-2 px-1' style={{ position: "relative", left: "20px" }} onClick={resetFilterFunc}>Reset</button>
      </div>
    </div>
  )
}

export default FilterComponent
